import React from 'react'
import PropTypes from 'prop-types'
import Select, { components } from 'react-select'
import { createUseStyles } from 'react-jss'

import { theme as localTheme } from '../../theme'
import SVG from '../../SVG/SVG'

const useStyles = createUseStyles(theme => ({
    groupLabel: {
        ...theme.paragraphs.bookingSelectTextStyle,
        fontStyle: 'italic',
        color: theme.colors.brushedsteel,
    },
    locationSelect: {
        '& .select__menu': {
            zIndex: 999,
        },
        '& .select__control': {
            border: 'none',
            borderRadius: theme.borderRadius,
            minHeight: 33,
        },
        '& .select__value-container': {
            ...theme.paragraphs.bookingSelectTextStyle,
            cursor: 'pointer',
            color: theme.colors.brushedsteel,
        },
        '& .select__dropdown-indicator': {
            padding: 6,
        },
        '& .select__dropdown-indicator svg path': {
            fill: theme.colors.blue,
        },
        '& .select__clear-indicator': {
            padding: 5,
        },
        '& .select__option': {
            ...theme.paragraphs.bookingSelectTextStyle,
            border: 'none',
            cursor: 'pointer',
            paddingLeft: 25,
        },
    },
    svgContainer: {
        paddingLeft: 10,
        paddingTop: 4,
    },
}))

const Placeholder = props => {
    return <components.Placeholder {...props} />
}

const colourStyles = {
    control: styles => ({ ...styles, backgroundColor: 'white' }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return {
            ...styles,
            backgroundColor: isDisabled
                ? null
                : isSelected
                ? localTheme.colors.sunflower
                : isFocused
                ? null
                : null,
            color: '#000000',
            cursor: isDisabled ? 'not-allowed' : 'default',
            fontSize: '13px',
            letterSpacing: '0.5px',
            lineHeight: '21px',
            paddingLeft: 25,
            ':active': {
                ...styles[':active'],
                backgroundColor: localTheme.colors.sunflower,
            },
            ':hover': {
                ...styles[':hover'],
                backgroundColor: localTheme.colors.sunflower,
            },
        }
    },
}

const SVGInContainer = () => {
    const classes = useStyles()
    return (
        <span className={classes.svgContainer}>
            <SVG name={'MapMarkerPlain'} colorOne={'#01396c'} width={13} height={17} />
        </span>
    )
}

const ValueContainer = ({ children, ...props }) => {
    return (
        <React.Fragment>
            <SVGInContainer />
            <components.ValueContainer {...props}>{children}</components.ValueContainer>
        </React.Fragment>
    )
}

// export const LocationSelect = ({ groupedOptions, isDisabled, isLoading  }) => {
export const LocationSelect = props => {
    const classes = useStyles()

    const formatGroupLabel = data => (
        <div className={classes.groupLabel}>
            <span>{data.label}</span>
        </div>
    )

    return (
        <React.Fragment>
            <Select
                name={props.name}
                value={props.pickupLocation}
                onChange={props.selectHandleChange}
                onInputChange={props.selectHandleInputChange}
                options={props.pickupOptions}
                className={classes.locationSelect}
                classNamePrefix="select"
                isDisabled={props.isDisabled}
                isLoading={props.isLoading}
                isClearable={false}
                isSearchable={false}
                components={{ ValueContainer, Placeholder }}
                placeholder={'Select a location'}
                formatGroupLabel={formatGroupLabel}
                styles={colourStyles}
            />
        </React.Fragment>
    )
}

// LocationSelect.propTypes = {
//   groupedOptions: PropTypes.arrayOf(PropTypes.shape({
//     value: PropTypes.string,
//     label: PropTypes.string
//   })),
//   isLoading: PropTypes.bool,
//   isDisabled: PropTypes.bool
// }

export default LocationSelect
